import { OverlayContainer } from '@angular/cdk/overlay';
import {
    Component,
    Input,
    OnInit,
    OnDestroy,
    HostBinding,
} from '@angular/core';
import { NgxUiLoaderService, SPINNER } from 'ngx-ui-loader';
import { interval, Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { EncryptorService } from '../../Services/encryptor.service';
@Component({
    selector: 'app-loading',
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.css'],
    standalone: false
})
export class LoadingComponent implements OnInit, OnDestroy {
    @Input('logo') withLogo: boolean = true;
    @Input('text') withChargingText: boolean = true;

    logo: string = '/assets/img/logo_itteh_white.png';

    /*lightLogos: string[] = [
        '/assets/img/logo_sep.png', // logoSep
        '/assets/img/logo_tecnm.png', // logoTecnm
        '/assets/img/logo_itteh.png', // logoItteh
    ];

    darkLogos: string[] = [
        '/assets/img/logo_sep_white.png', // logoSepWhite
        '/assets/img/logo_tecnm_white.png', // logoTecnmWhite
        '/assets/img/logo_itteh_white.png', // logoIttehWhite
    ];*/

    darkMode: boolean = true;

    themeKey = 'THEME';

    interval: Subscription;

    flag: number = 0;

    SPINNER = SPINNER;

    _fgsSize: number = 100;

    colorThemeKey = 'THEME-COLOR';

    @HostBinding('class') className = '';

    defaultColor: boolean = true;
    production: boolean = environment.production;
    check: boolean = environment.check;

    constructor(
        private ngxService: NgxUiLoaderService,
        private overlay: OverlayContainer,
        private encryptorService: EncryptorService
    ) {}

    ngOnInit(): void {
        this.checkTheme();
        if (this.withLogo) {
            this.setLogo(this.flag);
            this.interval = interval(333).subscribe(() => {
                this.changeLogo();
            });
        } else {
            this.fgsSize();
            this.ngxService.startLoader('loader');
            window.addEventListener('resize', () => {
                this.ngxService.stopLoader('loader');
                this.fgsSize();
                this.ngxService.startLoader('loader');
            });
        }
    }

    changeLogo() {
        this.flag = this.flag < 2 ? this.flag + 1 : 0;
        this.setLogo(this.flag);
    }

    setLogo(flag: number) {
        if (this.darkMode) {
            //this.logo = this.darkLogos[flag];
        } else {
            //this.logo = this.lightLogos[flag];
        }
    }

    fgsSize() {
        const height: number = window.screen.height;
        if (height < 300) {
            this._fgsSize = 60;
        } else if (height < 400) {
            this._fgsSize = 70;
        } else if (height < 500) {
            this._fgsSize = 80;
        } else if (height < 600) {
            this._fgsSize = 90;
        } else {
            this._fgsSize = 100;
        }
    }

    setTheme(darkMode: boolean) {
        const darkClassName = 'darkMode';
        const darkDevClassName = 'darkMode-dev';
        const lightClassName = 'lightMode';
        const lightblueClassName = 'lightMode-default';
        const lightRedClassName = 'lightMode-red';
       const lightGreenClassName = 'lightMode-check';

        this.className = this.production
            ? darkMode
                ? darkClassName
                : lightClassName
            : this.check
            ? lightGreenClassName
            : darkDevClassName;

        localStorage.setItem(
            this.themeKey,
            this.encryptorService.aesEncrypt(this.className)
        );

        this.overlay
            .getContainerElement()
            .classList.remove(
                darkClassName,
                lightblueClassName,
                lightRedClassName,
                darkDevClassName
            );

        if (!this.production) {
            this.overlay.getContainerElement().classList.add(darkDevClassName);
        } else if (darkMode) {
            this.overlay.getContainerElement().classList.add(darkClassName);
        } else {
            this.checkColorLightTheme();
        }
    }

    setColorLightTheme(defaultColor: boolean) {
        const lightClassName = 'lightMode';
        const lightblueClassName = 'lightMode-default';
        const lightRedClassName = 'lightMode-red';

        const redClassName = 'red';
        const blueClassName = 'blue';

        this.className = defaultColor ? lightblueClassName : lightRedClassName;

        const className = defaultColor ? blueClassName : redClassName;

        localStorage.setItem(
            this.colorThemeKey,
            this.encryptorService.aesEncrypt(className)
        );

        this.overlay
            .getContainerElement()
            .classList.remove(lightblueClassName, lightRedClassName);

        if (defaultColor) {
            this.overlay
                .getContainerElement()
                .classList.add(lightblueClassName);
        } else {
            this.overlay.getContainerElement().classList.add(lightRedClassName);
        }
    }

    checkTheme() {
        const classStoraged = localStorage.getItem(this.themeKey);
        const className = classStoraged
            ? this.encryptorService.aesDecrypt(classStoraged)
            : '';
        const darkMode = className == 'darkMode';

        this.setTheme(darkMode);

        this.darkMode = darkMode;
    }

    checkColorLightTheme() {
        const redClassName = 'red';

        const classStoraged = localStorage.getItem(this.colorThemeKey);
        const className = classStoraged
            ? this.encryptorService.aesDecrypt(classStoraged)
            : '';
        const defaultColor = className != redClassName;

        this.setColorLightTheme(defaultColor);

        this.defaultColor = defaultColor;
    }

    ngOnDestroy(): void {
        if (this.withLogo) this.interval.unsubscribe();
    }
}
